import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import Slide from "@material-ui/core/Slide";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { styles } from "./styles";

export const Transition = React.forwardRef((props, ref) => (
  <Slide direction="down" {...props} />
));

class DialogComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialogs: this.props.openDialogs || false,
    };
  }

  componentWillMount() {
    this.props.onRef(null);
  }

  componentDidMount() {
    this.props.onRef(this);
  }
  handleDialogOpen = () => {
    this.setState({ openDialogs: true });
  };
  handleDialogClose = () => {
    this.setState({ openDialogs: false });
  };

  render() {
    const { classes, handleActionDialogClose } = this.props;
    return (
      <div className={classes.wrapDialog}>
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={this.state.openDialogs}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleDialogClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          {this.props.title ? (
            <DialogTitle id="alert-dialog-slide-title" disableTypography={true}>
              <Typography variant="h5" className={classes.title}>
                {this.props.title}
              </Typography>
            </DialogTitle>
          ) : (
            ""
          )}
          {this.props.content ? (
            <>
              <Divider />

              <DialogContent>
                <div
                  id="alert-dialog-slide-description"
                  className={classes.containerContent}
                >
                  <Typography variant="body1" className={classes.content}>
                    {this.props.content}
                  </Typography>
                </div>
              </DialogContent>
            </>
          ) : (
            ""
          )}

          <Divider />
          <DialogActions className={classes.containerAction}>
            {this.props.disagree ? (
              <Button
                onClick={
                  handleActionDialogClose
                    ? handleActionDialogClose
                    : this.handleDialogClose
                }
                color="default"
              >
                {this.props.disagree}
              </Button>
            ) : (
              ""
            )}
            {this.props.agree ? (
              <Button
                onClick={this.props.action}
                variant="contained"
                color="primary"
              >
                {this.props.agree}
              </Button>
            ) : (
              ""
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

DialogComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(DialogComponent)
  )
);
